import { ActivatedRoute } from '@angular/router';
import { FilterFieldValue } from '../../covance-filter/covance-filter.models';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LabResultsFilterStorage } from './lab-results-filter-storage';
import { SponsorStandardTestResultsStorage } from './sponsor-standard-test-results-storage';
import { SITE_LAB_RESULTS_STORAGE } from '../../on-screen-results/standard-test-results/site-test-data-storage';
import { map, withLatestFrom, switchMap, takeWhile } from 'rxjs/operators';
import { routeData } from '../../shared/route-helpers';
import { LOAD_ALL_RESULTS_QUERY_PARAMETER } from '../../on-screen-results/standard-test-results/standart-test-result-query-parameters';
import { SponsorStudySiteIdentity } from '../sites/sponsor-study-site-identity';


@Component({
    selector: 'sponsor-standard-test-results',
    template: require('./sponsor-standard-test-results.component.html'),
    styles: [require('./sponsor-standard-test-results.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        { provide: SITE_LAB_RESULTS_STORAGE, useClass: SponsorStandardTestResultsStorage }
    ]
})
export class SponsorStandardTestResultsComponent {
    public filterDefinitions: Observable<FilterFieldValue[]>;
    public showLargeSiteWarning: Observable<boolean>;
    public siteId$: Observable<number>;

    constructor(
        filterStorage: LabResultsFilterStorage,
        route: ActivatedRoute,
    ) {
        const currentSiteIdentity = route.parent.data.pipe(map(d => d[routeData.selectedSiteIdentity] as SponsorStudySiteIdentity));
        this.siteId$ = currentSiteIdentity.pipe(map(s => s.siteId));
        this.filterDefinitions = filterStorage.siteDataFilterFields;
        const isLargeSite$ = currentSiteIdentity.pipe(map((s) => !!s && s.isExtremelyLarge));
        this.showLargeSiteWarning = isLargeSite$
            .pipe(
                switchMap(_ =>
                    route.parent.queryParams
                        .pipe(
                            map(p => !!p[LOAD_ALL_RESULTS_QUERY_PARAMETER]),
                            withLatestFrom(isLargeSite$),
                            map(([loadAll, isLarge]) => isLarge && !loadAll),
                            takeWhile(r => r, true))));
        
    }
}
